import { Component, OnInit } from "@angular/core";
import { GeneralService } from "../../services/general.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(private generalService: GeneralService) {}
  genericDetails: any = [];

  ngOnInit(): void {
    this.generalService.getGenericDetailsData().subscribe((data) => {
      this.genericDetails = data;
    });
  }
}
